import moment from "moment";
import {
  getCityOptions,
  getProvinceOptions
} from "../../utils/cityPickerOptions";
// import {} "../../api/report";
import { pickerOptions } from "../../utils/datePickerOptions";
const state = {
  currentReportId: undefined,
  currentReportDetail: {},
  datePickerOptions: pickerOptions
};

const getters = {
  currentReportDetail: state => state.currentReportDetail
};
const mutations = {
  UPDATE_CURRENT_REPORT_DETAIL(state, newValue) {
    console.log("qweqweqwe");
    state.currentReportDetail = newValue;
  }
};
const actions = {
  fetchCityOptions({ commit }) {
    getCityOptions().then(data => {
      commit("UPDATE_CITY_OPTIONS", data);
    });
  },
  fetchProvinceOptions({ commit }) {
    getProvinceOptions().then(data => {
      commit("UPDATE_PROVINCE_OPTIONS", data);
    });
  }
};

export default { state, actions, mutations, getters };



// WEBPACK FOOTER //
// ./src/store/modules/report.js